import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import WebFont from 'webfontloader';
import i18n from './i18n/i18n'

WebFont.load({
   google: {
     families: ['Be+Vietnam+Pro:600,400,700', 'sans-serif']
   }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);